import { Injectable } from '@angular/core';
import { ApiLoadingService } from './api-loading.service';
import { ApiCallService } from './api-call.service';
import { Partner } from './../models/index';
import { Resolve } from '@angular/router';

@Injectable()
export class PartnerService implements Resolve<Partner[]> {
  constructor(
    private apiLoadingService: ApiLoadingService,
    private apiCallService: ApiCallService
  ) { }

  getPartners(): Promise<Partner[]> {
    return this.apiCallService.get('/partners');
  }

  resolve(): Promise<Partner[]> {
    const promise = this.getPartners();

    this.apiLoadingService.startLoading(promise);

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/partner.service.ts